<div *ngIf="zVersion==='B2'" data-cy="tdo-enum-select-b2-version-container">

<div #main *ngIf="this.validValueItems && this.validValueItems.length > 0" class="ui-dark-background tdo-enum-select tdo-dropdown-v2 hide-underline"  style="width: 100%; height: fit-content; overflow: hidden; display: flex;flex-direction: column;margin-top: -5px;"   [ngStyle]="{'width': widthString,  'border-bottom': !isHideUnderline ? '1px solid var(--tdo-primary)' : 'unset' }"  data-cy="tdo-enum-select-main-container">
  <ng-container *ngIf="placeholderPosition === 'above'">
    <div class="tdo-enum-select-placeholder" style="flex-basis: fit-content;line-height: 1; margin-bottom: 1px;" data-cy="tdo-enum-select-placeholder-above">
      {{placeholder}}
      <span *ngIf="isRequired" style="color: red;" data-cy="tdo-enum-select-required-indicator">*</span>
      <span *ngIf="!isRequired" style="color: red; font-size: large;" data-cy="tdo-enum-select-optional-indicator">&nbsp;</span>
    </div>
  </ng-container>
  <mat-form-field style="width: 100%; position: relative; overflow-y: visible; height: 24px; " data-cy="tdo-enum-select-form-field">
    <mat-select [value]="value" (closed)="onClosed()" (valueChange)="onValueChange($event)" (selectionChange)="onSelectionChange($event)"
         [formControl]="selected" [multiple]="isMultiSelect" [placeholder]="placeholderPosition === 'above'? '' : placeholder" [floatLabel]="placeholderPosition === 'above'? 'always' :''" data-cy="tdo-enum-select-select">
      <mat-select-trigger *ngIf="isMultiSelect" data-cy="tdo-enum-select-select-trigger">
        {{selected.value && selected.value.length > 0 && selected.value[0] !== allLabel ? selected?.value[0][displayProperty] : (selected.value && selected.value.length > 0) ? selected.value[0] : ''}}
        <ng-container>
          <span *ngIf="selected.value?.length > 1" class="tdo-dropdown-additional-selection" data-cy="tdo-enum-select-additional-selection-count">
            (+{{selected.value.length - 1}} {{selected.value?.length === 2 ? 'other' : 'others'}})
          </span>
        </ng-container>
      </mat-select-trigger>
      <ng-container *ngIf="isIncludeAll">
        <mat-option (onSelectionChange)="onAllSelectionChange($event)" [value]="allObject" data-cy="tdo-enum-select-option-all">{{allLabel}}</mat-option>
      </ng-container>
      <ng-container *ngFor="let obj of datasource; let i = index">
        <mat-option (onSelectionChange)="onParentSelectionChange($event, obj, obj[innerDataSourcePropertyName])" #parent [value]="obj" [attr.data-cy]="'tdo-enum-select-option-' + i">
          <ng-container *ngIf="!displayPredicate">{{obj[displayProperty]}}</ng-container>
          <ng-container *ngIf="displayPredicate">{{displayPredicate(obj)}}</ng-container>
        </mat-option>
        <ng-container *ngIf="innerDataSourcePropertyName.length > 0">
          <mat-option (onSelectionChange)="onSelectionChildChange($event, innerObj)" #child style="color: var(--tdo-primary); margin-left: 14px;" [value]="innerObj" *ngFor="let innerObj of obj[innerDataSourcePropertyName]; let j = index" [attr.data-cy]="'tdo-enum-select-inner-option-' + i + '-' + j">{{innerObj[innerDataSourceDisplayName]}}</mat-option>
        </ng-container>
      </ng-container>
    </mat-select>
  </mat-form-field>
</div>

<ng-template #enumOptionsMenu let-data>
  <section style="border: 1px solid var(--tdo-secondary);" class="context-menu" data-cy="tdo-enum-select-options-menu">
    <div (click)="onClearValue()" class="item" data-cy="tdo-enum-select-clear-value-button">Clear</div>
    <div (click)="onEditList()" class="item" data-cy="tdo-enum-select-edit-list-button">Edit List</div>
  </section>
</ng-template>

</div>

<div *ngIf="zVersion==='L1'" data-cy="tdo-enum-select-l1-version-container">

  {{staticLabel}}

</div>

<div *ngIf="zVersion==='Z1'" data-cy="tdo-enum-select-z1-version-container">

  <!-- calendar use only as of 9/2023 -->

  <mat-select [value]="value" (closed)="onClosed()" (valueChange)="onValueChange($event)" (selectionChange)="onSelectionChange($event)"
    [formControl]="selected" [multiple]="isMultiSelect" [placeholder]="placeholderPosition === 'above'? '' : placeholder" [floatLabel]="placeholderPosition === 'above'? 'always' :''" data-cy="tdo-enum-select-calendar-select">
  <mat-select-trigger *ngIf="isMultiSelect" data-cy="tdo-enum-select-calendar-select-trigger">
  {{selected.value && selected.value.length > 0 && selected.value[0] !== allLabel ? selected?.value[0][displayProperty] : (selected.value && selected.value.length > 0) ? selected.value[0] : ''}}
  <ng-container>
    <span *ngIf="selected.value?.length > 1" class="tdo-dropdown-additional-selection" data-cy="tdo-enum-select-calendar-additional-selection-count">
      (+{{selected.value.length - 1}} {{selected.value?.length === 2 ? 'other' : 'others'}})
    </span>
  </ng-container>
  </mat-select-trigger>
  <ng-container *ngIf="isIncludeAll">
  <mat-option (onSelectionChange)="onAllSelectionChange($event)" [value]="allObject" data-cy="tdo-enum-select-calendar-option-all">{{allLabel}}</mat-option>
  </ng-container>
  <ng-container *ngFor="let obj of datasource; let i = index">
  <mat-option (onSelectionChange)="onParentSelectionChange($event, obj, obj[innerDataSourcePropertyName])" #parent [value]="obj" [attr.data-cy]="'tdo-enum-select-calendar-option-' + i">
    <ng-container *ngIf="!displayPredicate">{{obj[displayProperty]}}</ng-container>
    <ng-container *ngIf="displayPredicate">{{displayPredicate(obj)}}</ng-container>
  </mat-option>
  <ng-container *ngIf="innerDataSourcePropertyName.length > 0">
    <mat-option (onSelectionChange)="onSelectionChildChange($event, innerObj)" #child style="color: var(--tdo-primary); margin-left: 14px;" [value]="innerObj" *ngFor="let innerObj of obj[innerDataSourcePropertyName]; let j = index" [attr.data-cy]="'tdo-enum-select-calendar-inner-option-' + i + '-' + j">{{innerObj[innerDataSourceDisplayName]}}</mat-option>
  </ng-container>
  </ng-container>
  </mat-select>


</div>
